import { PLACEHOLDER } from '../RecentSoldPrices/RecentSoldPrices.consts';
import RecentSoldPricesTexts from '../RecentSoldPrices/RecentSoldPrices.texts';

export default {
	...RecentSoldPricesTexts,
	labels: {
		mileage: 'Mileage',
		regYear: 'Reg year',
		serviceHistory: 'Service history',
		soldPriceAndDate: '*{soldPrice}* on *{soldDate}*',
	},
	serviceHistory: {
		full: 'Full service',
		no: 'No service',
		not_applicable: 'Service not due',
		partial: 'Partial service',
		skipped: PLACEHOLDER,
		yes: 'Service available',
	},
};
